import Swiper, { FreeMode, Scrollbar } from "swiper";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/scrollbar";

export default class StoryTab {
    constructor() {
        this.$story = document.querySelector(".howto4th-story");
        this.$tabs = this.$story ? [...this.$story.querySelectorAll("[data-story-tab]")] : [];
        this.$panels = this.$story ? [...this.$story.querySelectorAll("[data-story-panel]")] : [];
        this.mediaQuery = window.matchMedia("(max-width: 768px)");
        this.teamSwipers = [];

        if (!this.$story) return;

        this._setTabs();
        this._setTeamSwipers();

        if (this.mediaQuery.addEventListener) {
            this.mediaQuery.addEventListener("change", () => this._setTeamSwipers());
        } else {
            this.mediaQuery.addListener(() => this._setTeamSwipers());
        }
    }

    _setTabs() {
        this.$tabs.forEach(($tab, index) => {
            $tab.addEventListener("click", () => this._selectTab($tab.dataset.storyTab));
            $tab.addEventListener("keydown", (event) => this._handleKeydown(event, index));
        });
    }

    _selectTab(season) {
        const isCurrentSeason = this.$panels.some(($panel) => $panel.dataset.storyPanel === season && $panel.classList.contains("-active"));

        if (isCurrentSeason) return;

        this.$tabs.forEach(($tab) => {
            const isActive = $tab.dataset.storyTab === season;
            $tab.classList.toggle("-active", isActive);
            $tab.setAttribute("aria-selected", isActive ? "true" : "false");
            $tab.setAttribute("tabindex", isActive ? "0" : "-1");
        });

        this.$panels.forEach(($panel) => {
            const isActive = $panel.dataset.storyPanel === season;
            $panel.classList.toggle("-active", isActive);
            $panel.hidden = !isActive;

            if (isActive) {
                this._playPanel($panel);
            }
        });

        this.teamSwipers.forEach((swiper) => swiper.update());
    }

    _playPanel($panel) {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        $panel.classList.remove("-play", "-viewed");
        void $panel.offsetWidth;
        $panel.classList.add("-play");
    }

    _handleKeydown(event, currentIndex) {
        const lastIndex = this.$tabs.length - 1;
        let nextIndex = currentIndex;

        if (event.key === "ArrowRight") nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
        if (event.key === "ArrowLeft") nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = lastIndex;
        if (nextIndex === currentIndex && !["Home", "End"].includes(event.key)) return;

        event.preventDefault();
        this.$tabs[nextIndex].focus();
        this._selectTab(this.$tabs[nextIndex].dataset.storyTab);
    }

    _setTeamSwipers() {
        if (this.mediaQuery.matches && this.teamSwipers.length === 0) {
            this.teamSwipers = [...this.$story.querySelectorAll(".js-howto4th-story-teams")].map(
                ($slider) =>
                    new Swiper($slider, {
                        modules: [FreeMode, Scrollbar],
                        slidesPerView: "auto",
                        spaceBetween: 4,
                        freeMode: true,
                        observer: true,
                        observeParents: true,
                        scrollbar: {
                            el: $slider.querySelector(".swiper-scrollbar"),
                            draggable: true,
                        },
                    })
            );
        }

        if (!this.mediaQuery.matches && this.teamSwipers.length > 0) {
            this.teamSwipers.forEach((swiper) => swiper.destroy(true, true));
            this.teamSwipers = [];
        }
    }
}
